/**
 * Debug-gated console logging for verbose Playground, snapshot, and lifecycle
 * diagnostics.
 *
 * Silent by default in every environment so the browser console only surfaces
 * essentials (warnings and errors). Enable explicitly at runtime with
 * `?milesDebug=1` in the URL or `localStorage.milesDebug = '1'`.
 *
 * Use this instead of `console.log` / `console.info` / `console.debug` for
 * any diagnostic output. Keep `console.warn` / `console.error` for genuine
 * anomalies that should always be visible.
 */
function resolveDebugEnabled(): boolean {
  try {
    if (typeof window === 'undefined') {
      return false;
    }

    if (new URLSearchParams(window.location.search).get('milesDebug') === '1') {
      return true;
    }

    return window.localStorage?.getItem('milesDebug') === '1';
  } catch {
    return false;
  }
}

const debugEnabled = resolveDebugEnabled();

export function debugLog(...args: unknown[]): void {
  if (debugEnabled) {
    console.log(...args);
  }
}
